import * as React from "react";
const CmsEmpty = ({ component, page }) => {
  const preview = page.isPreview();
  if (!preview) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", null, component?.getName());
};
export {
  CmsEmpty,
  CmsEmpty as default
};
//# sourceMappingURL=Empty.js.map
